import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NormalTable',
  props: {
    hasPaggination: { type: Boolean },
    pageNum: null,
    pageSize: null,
    pageTotal: null,
    noMiniSize: { type: Boolean },
    tdLeft: { type: Boolean },
    noHorver: { type: Boolean },
    noBorder: { type: Boolean }
  },
  emits: ["size-change", "current-change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'size-change', value: number),
    (e: 'current-change', value: number)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    hasPaggination?: boolean
    pageNum?: number
    pageSize?: number
    pageTotal?: number
    noMiniSize?: boolean
    tdLeft?: boolean
    noHorver?: boolean
    noBorder?: boolean
}




function onSizeChange(value: number) {
    emits('size-change', value)
}

function onCurrentChange(value: number) {
    emits('current-change', value)
}
const tableStyle = computed(() => {
    if (props.noMiniSize) {
        return {

        }
    } else {
        return {
            'min-height': '400px'
        }
    }
})

return { __sfc: true,props, emits, onSizeChange, onCurrentChange, tableStyle }
}

})